// KonexoCRM design tokens — single source of truth
// Pastel + accent palette

export const STATUS_TONES = {
  // Green — success
  completed: { bg: "bg-emerald-100", text: "text-emerald-700", ring: "ring-emerald-200", label: "Completed" },
  confirmed: { bg: "bg-emerald-100", text: "text-emerald-700", ring: "ring-emerald-200", label: "Confirmed" },
  accepted:  { bg: "bg-emerald-100", text: "text-emerald-700", ring: "ring-emerald-200", label: "Accepted" },
  delivered: { bg: "bg-emerald-100", text: "text-emerald-700", ring: "ring-emerald-200", label: "Delivered" },
  responded: { bg: "bg-emerald-100", text: "text-emerald-700", ring: "ring-emerald-200", label: "Responded" },
  active:    { bg: "bg-emerald-100", text: "text-emerald-700", ring: "ring-emerald-200", label: "Active" },
  // Orange — pending
  pending: { bg: "bg-amber-100", text: "text-amber-700", ring: "ring-amber-200", label: "Pending" },
  hold:    { bg: "bg-amber-100", text: "text-amber-700", ring: "ring-amber-200", label: "On Hold" },
  todo:    { bg: "bg-amber-100", text: "text-amber-700", ring: "ring-amber-200", label: "To Do" },
  // Blue — in progress / assigned
  in_progress: { bg: "bg-sky-100", text: "text-sky-700", ring: "ring-sky-200", label: "In Progress" },
  assigned:    { bg: "bg-sky-100", text: "text-sky-700", ring: "ring-sky-200", label: "Assigned" },
  placed:      { bg: "bg-sky-100", text: "text-sky-700", ring: "ring-sky-200", label: "Placed" },
  // Purple — quoted
  quoted: { bg: "bg-violet-100", text: "text-violet-700", ring: "ring-violet-200", label: "Quoted" },
  // Indigo — converted to order, locked/read-only
  converted: { bg: "bg-indigo-100", text: "text-indigo-700", ring: "ring-indigo-200", label: "Converted · Read Only" },
  // Red — cancelled / closed
  cancelled: { bg: "bg-red-100", text: "text-red-700", ring: "ring-red-200", label: "Cancelled" },
  closed:    { bg: "bg-slate-100", text: "text-slate-600", ring: "ring-slate-200", label: "Closed" },
  // Grey — inactive
  inactive: { bg: "bg-slate-100", text: "text-slate-500", ring: "ring-slate-200", label: "Inactive" },
};

export const PASTEL = {
  emerald: { card: "bg-emerald-50", icon: "bg-emerald-500 text-white", ring: "hover:ring-emerald-200" },
  indigo:  { card: "bg-indigo-50",  icon: "bg-indigo-500 text-white",  ring: "hover:ring-indigo-200" },
  amber:   { card: "bg-amber-50",   icon: "bg-amber-500 text-white",   ring: "hover:ring-amber-200" },
  sky:     { card: "bg-sky-50",     icon: "bg-sky-500 text-white",     ring: "hover:ring-sky-200" },
  violet:  { card: "bg-violet-50",  icon: "bg-violet-500 text-white",  ring: "hover:ring-violet-200" },
  rose:    { card: "bg-rose-50",    icon: "bg-rose-500 text-white",    ring: "hover:ring-rose-200" },
};

export const CARD_BASE =
  "rounded-2xl shadow-sm border border-transparent transition-all duration-200 hover:shadow-md hover:-translate-y-0.5";
